import { render, staticRenderFns } from "./LostItemRegistration.vue?vue&type=template&id=5c6fcbc4&scoped=true&"
import script from "./LostItemRegistration.vue?vue&type=script&lang=js&"
export * from "./LostItemRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fcbc4",
  null
  
)

export default component.exports